import type { ReactElement } from 'react';
import { NavLink, Outlet } from 'react-router';
import { useAuth } from '../auth/AuthProvider.js';

const NAV = [
  { to: '/interviews', label: 'Interviews' },
  { to: '/job-profiles', label: 'Job profiles' },
  { to: '/interviewers', label: 'Interviewers' },
];

export function AppLayout(): ReactElement {
  const { user, logout } = useAuth();

  return (
    <div className="flex h-full flex-col">
      <header className="flex shrink-0 items-center justify-between gap-6 border-b border-session-border bg-session-panel px-6 py-3">
        <div className="flex items-center gap-6">
          <span className="text-sm font-semibold tracking-tight text-session-text">
            Proctoring <span className="text-session-dim">Backoffice</span>
          </span>
          <nav className="flex items-center gap-1" aria-label="Main">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `rounded-md px-3 py-1.5 text-sm transition-colors ${
                    isActive
                      ? 'bg-session-panel-raised text-session-text'
                      : 'text-session-muted hover:text-session-text'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-4">
          {user ? <span className="text-sm text-session-muted">{user.fullName}</span> : null}
          <button type="button" onClick={logout} className="btn-secondary px-3 py-1.5 text-xs">
            Sign out
          </button>
        </div>
      </header>

      <main className="min-h-0 flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
